import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PlatformDouyin"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M20.9731 10.1925C19.1433 10.1925 17.4485 9.60112 16.0616 8.59539V15.8218C16.0616 19.5101 13.1375 22.5 9.53082 22.5C5.92385 22.5 3 19.5101 3 15.8218C3 12.1337 5.92389 9.14388 9.53082 9.14388C9.88917 9.14388 10.2405 9.17403 10.5832 9.23085V13.0595C10.2553 12.9333 9.90792 12.8689 9.55766 12.8691C7.94808 12.8691 6.64312 14.2033 6.64312 15.8494C6.64312 17.4955 7.94808 18.8298 9.55766 18.8298C11.1674 18.8298 12.4722 17.4955 12.4722 15.8494C12.4722 15.8401 12.4717 15.8312 12.4715 15.8218L12.4722 1.5H16.1155C16.1155 4.25844 18.3025 6.49473 21 6.49473V10.1921C20.991 10.1921 20.982 10.1925 20.9731 10.1925Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PlatformDouyin.vue"]]);
